import {ChangeDetectionStrategy, Component} from '@angular/core';
import { ItemService, UserDetailsComponent, UserItemService, DisableInfoComponent } from '@spartacus/organization/administration/components';
import { ICON_TYPE } from '../../model/user-profiles-icon.model';
import { EfaOrgCardComponent } from '../efa-org-card/efa-org-card.component';
import { FocusDirective, IconComponent } from '@spartacus/storefront';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { EfaToggleStatusComponent } from '../efa-toggle-status/efa-toggle-status.component';
import { AsyncPipe } from '@angular/common';
import { JoinByPipe } from '../../../shared/pipes/join-By.pipe';
import { TranslatePipe, UrlPipe } from '@spartacus/core';


@Component({
    selector: 'app-efa-org-user-details',
    templateUrl: './efa-user-details.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: ItemService,
            useExisting: UserItemService,
        },
    ],
    host: { class: 'content-wrapper' },
    imports: [EfaOrgCardComponent, FocusDirective, RouterLink, IconComponent, EfaToggleStatusComponent, DisableInfoComponent, RouterLinkActive, AsyncPipe, JoinByPipe, TranslatePipe, UrlPipe]
})
export class EfaUserDetailsComponent extends UserDetailsComponent{
  iconTypes = ICON_TYPE;
}
